import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import Logo from '../images/logo-white-bg.png';

const styles = theme => ({
    root: {
        background: 'var(--e-global-color-88b478a)',
        position: 'relative',
        zIndex: '1000',
        boxShadow: 'none !important',
        maxWidth: '800px',
        margin: '0 auto'
    },
    subNavRoot: {
        position: 'relative',
        marginBottom: '1em'
    },
    subNavLinks: {
        '& a': {
            color: 'var(--e-global-color-primary)',
            marginLeft: '.4em',
            marginRight: '.4em',
            padding: '0.75em 0',
            display: 'inline-block',
            textDecoration: 'none',
            textTransform: 'uppercase',
            fontFamily: 'var(--e-global-typography-font-family) !important',
            fontWeight: 'var(--e-global-typography-primary-font-weight)',
            fontSize: '17px',
            '&:hover': {
                paddingBottom: '0.5em',
                borderBottom: '0.25em solid var(--e-global-color-accent)'
            }
        }
    },
    heading: {
        paddingTop: '20px',
        // marginRight: '80px',
        color: '#fff',
        fontSize: '40px',
        [theme.breakpoints.down('sm')]: {
            fontSize: '28px'
        }
    },
    toolbar: {
        justifyContent: 'center'
    },
    subNavToolbar: {
        minHeight: '0',
        justifyContent: 'center',
        paddingLeft: '8px !important',
        paddingRight: '8px !important'
    },
    logo: {
        display: 'block',
        width: 240,
        marginTop: 10,
        marginBottom: 20
    }
});

const Header = ({ classes, isAuthenticated, handleAuth }) => {
    const onSignOut = async e => {
        e.preventDefault();
        try {
            await Auth.signOut();
            handleAuth(false);
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <div style={{ marginBottom: '30px' }}>
            <AppBar className={classes.root} position="static" color="default">
                <Toolbar className={classes.toolbar}>
                    <Typography
                        className={classes.heading}
                        component="h1"
                        variant="h3"
                        align="left"
                    >
                        <Link to="/">
                            <img
                                className={classes.logo}
                                src={Logo}
                                alt="Dartline logo"
                            />
                        </Link>
                    </Typography>
                </Toolbar>
            </AppBar>

            <div className={classes.subNavRoot} color="default">
                <Toolbar className={classes.subNavToolbar}>
                    <Typography
                        className={classes.subNavLinks}
                        component="div"
                        variant="body2"
                        align="center"
                    >
                        <Link to="/">My tickets</Link>
                        {isAuthenticated && (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <Link to="/account">Account</Link>
                        )}
                        <Link to="/help">Help</Link>
                        {isAuthenticated && (
                            // eslint-disable-next-line jsx-a11y/anchor-is-valid
                            <a href="#" onClick={onSignOut}>
                                Logout
                            </a>
                        )}
                    </Typography>
                </Toolbar>
            </div>
        </div>
    );
};

Header.propTypes = {
    classes: PropTypes.shape().isRequired
};

export default withStyles(styles)(Header);
